/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import EventPageDesign from '/client/src/pages/Events/detail/design';
import SaveBtn from '../saveBtn';
import { withRouter } from 'react-router-dom';
import { GET } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';
import { ToggleLeftMenu } from '/client/src/utils/animation';

type NewDesignPropsType = {
  onHandleChangeStepNavBar: () => void,
  match: {
    params: {
      eventId?: string | number,
      viewTab?: string
    }
  }
};

class NewDesign extends React.Component<NewDesignPropsType> {
  props: PropsType;

  state = {
    eventDetail: null
  };

  componentDidMount() {
    ToggleLeftMenu('hide');
    this.handleLoad();
  }

  componentWillUnmount() {
    ToggleLeftMenu('show');
  }

  handleLoad = async () => {
    const { match: { params } } = this.props;

    try {
      CssPinner(document.body, true);
      NProgressCustom(true);
      const { result } = await GET(`/api/v1/1/events/${params.eventId}/detail`);

      this.setState({
        eventDetail: result
      }, () => {
        CssPinner(document.body, false);
        NProgressCustom(false);
      });
    } catch (e) {
      console.log(e);
      CssPinner(document.body, false);
      NProgressCustom(false);
    }
  };

  render(): React.Element<'div'> {
    const { eventDetail } = this.state;
    const { match: { params }, onHandleChangeStepNavBar } = this.props;

    return (
      <>
        <div className='splash-create-tip'>
          <h2>Design Your Splash Page!</h2>
          <p>
            Captain, make a splash by dragging and dropping pictures, videos, audio and text.
          </p>
        </div>

        {eventDetail ?
          <>
            <EventPageDesign {...this.props} eventDetail={eventDetail} />
            <SaveBtn
              handleSave={() => {
                this.props.history.push(`/events/new/${params.eventId}/collaborators`);
                onHandleChangeStepNavBar(3);
              }}
              onHandleChangeStepNavBar={onHandleChangeStepNavBar}
              isNew={params.viewTab !== 'edit'}
              text={params.viewTab === 'edit' ? 'Save' : 'Save & Next'}
            />
          </> :
          null
        }
      </>
    );
  }
}

export default withRouter(NewDesign);
